import {Lang} from 'yougile-lang'
import {Tag} from 'yougile-model'
import {Sticker} from '@extensions/sticker/sticker'

export const getStickerTypeMessage = (sticker: Tag): string => {
  switch (Sticker.getType(sticker)) {
    case 'string':
      return Lang.msg.myStickers.stickerWithStatuses
    case 'sprint':
      return Lang.msg.myStickers.stickerWithDateIntervals
    case 'text':
      return Lang.msg.myStickers.stickerWithText
    case 'numeric':
      return Lang.msg.myStickers.stickerWithNumber
    default:
      return Lang.msg.myStickers.system
  }
}
